import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ServiceProviderService } from 'src/app/shared/services/service-provider.service';
import { GenericServiceProvider } from '../../classes/generic-service-provider';
import { DynamicFormStructure } from '../../dynamic-form-structure';
import { SiteService } from 'src/app/shared/services/site.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-medical-certificate',
  templateUrl: './medical-certificate.component.html',
  styleUrls: ['./medical-certificate.component.scss'],
})
export class MedicalCertificateComponent
  extends GenericServiceProvider
  implements OnInit, OnDestroy, AfterViewInit
{
  constructor(
    _siteService: SiteService,
    _modalService: ModalService,
    _messageService: MessageService,
    _serviceProviderService: ServiceProviderService
  ) {
    super(_siteService, _modalService, _messageService, _serviceProviderService);
  }

  ngOnInit(): void {
    const dynamicFormStructure = new DynamicFormStructure();

    super.ngOnInit(dynamicFormStructure.getMedicalCertificateStructure());
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
